/* eslint-disable global-require */
module.exports = ['indexes.others'];
